import { useMemo } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import type { Tab } from "./NotificationContext";
import { TABS } from "./NotificationContext";

export const useV2TabsList = (): Tab[] => {
  const { currentCommunitySettings, currentCommunityMember } =
    usePunditUserContext();
  const isNotificationsTabV2Enabled =
    currentCommunitySettings?.live_pulse_notifications_tab_v2_enabled;

  const isAdminOrModerator =
    currentCommunityMember?.is_admin || currentCommunityMember?.is_moderator;

  return useMemo(() => {
    const tabsList = Object.values(TABS);

    if (isNotificationsTabV2Enabled) {
      if (!isAdminOrModerator) {
        return tabsList.filter(
          tab => tab !== TABS.ARCHIVED && tab !== TABS.MODERATION,
        );
      }

      return tabsList.filter(tab => tab !== TABS.ARCHIVED);
    }

    return tabsList.filter(
      tab => tab !== TABS.CONTENT && tab !== TABS.MODERATION,
    );
  }, [isNotificationsTabV2Enabled, isAdminOrModerator]);
};
